import React from 'react'
import {createRoot} from 'react-dom/client'
// import * as serviceWorker from './serviceWorker';
import {App} from './app/App'

const container = document.getElementById('root')
if (!container) {
  throw new Error('Root container #root not found in index.html')
}
const root = createRoot(container)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
